import { API_ORGANIZATION_URL } from "../config";
import { getToken } from "../Utils/Auth";
import { getWithToken } from "./apiRequets";



async function getAllTimeSafeOrganizations(): Promise<any> {
    return new Promise(async (resolve, reject) => {
        const token = await getToken();
        const parameter = {};
        const response = await getWithToken(token, API_ORGANIZATION_URL, parameter) // force break
            .catch((error: string) => reject(error));

        if (response.ok) {
            let body = await response.json();
            resolve(body);
        } else {
            reject(response.statusText);
        }
    });
}

export default { getAllTimeSafeOrganizations };

/*
import { getToken } from "../Utils/Auth";
import { API_TIMESAFE_URL} from "../config";
import { getWithToken } from "./apiRequets";


async function getAllTimeSafeOrganizations(): Promise<any> {
    return new Promise(async (resolve, reject) => {
        const token = await getToken();
        const parameter = {};
        const response = await getWithToken(token, API_TIMESAFE_URL, parameter) // force break
            .catch((error: string) => reject(error));

        if (response.ok) {
            let body = await response.json();
            resolve(body);
        } else {
            reject(response.statusText);
        }
    });
}

export default { getAllTimeSafeOrganizations };*/
